var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bg-white padding-5"},[_c('video',{attrs:{"width":"100%","height":"auto","src":_vm.videoUrl,"controls":""}},[_vm._v("\n    Your browser does not support the video tag.\n  ")])])}
var staticRenderFns = []

export { render, staticRenderFns }